var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIwflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 160",
    width: 550,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 160,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 220,
    height: 20,
    fill: "#0038B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 120,
    width: 220,
    height: 20,
    fill: "#0038B8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,80) scale(3.5)",
    fill: "none",
    stroke: "#0038B8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-10 8.66,5 -8.66,5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,10 -8.66,-5 8.66,-5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwflag);
export default __webpack_public_path__ + "static/media/iwflag.e3607a6e85091bb5a338b589c3a2b29d.svg";
export { ForwardRef as ReactComponent };